export default [
	{ label: 'Athlete', key: 'athlete' },
	{ label: 'FirstName', key: 'firstName' },
	{ label: 'Suffix', key: 'suffix' },
	{ label: 'MiddleInitial', key: 'middleInitial' },
	{ label: 'LastName', key: 'lastName' },
	{ label: 'Gender', key: 'gender' },
	{ label: 'DOB', key: 'dob' },
	{ label: 'MembershipId', key: 'membershipId' },
	{ label: 'BaseMembershipStatus', key: 'baseMembershipStatus' },
	{ label: 'JuniorGoldMembershipStatus', key: 'juniorGoldMembershipStatus' },
	{ label: 'MembershipPurchaseDate', key: 'membershipPurchaseDate' },
	{ label: 'MembershipType', key: 'membershipType' },
  { label: 'IsStandardYouth', key: 'isStandardYouth' },
  { label: 'IsStandardAdult', key: 'isStandardAdult' },
  { label: 'IsCollegiateYouth', key: 'isCollegiateYouth' },
  { label: 'IsCollegiateAdult', key: 'isCollegiateAdult' },
  { label: 'IsSpecialOlympicsYouth', key: 'isSpecialOlympicsYouth' },
  { label: 'IsSpecialOlympicsAdult', key: 'isSpecialOlympicsAdult' },
	{ label: 'IsBaseActive', key: 'isBaseActive' },
  { label: 'IsJuniorGoldU12', key: 'isJuniorGoldU12' },
  { label: 'IsJuniorGoldU14', key: 'isJuniorGoldU14' },
  { label: 'IsJuniorGoldU16', key: 'isJuniorGoldU16' },
  { label: 'IsJuniorGoldU18', key: 'isJuniorGoldU18' },
  { label: 'IsJuniorGoldU15U17U20', key: 'isJuniorGoldU15U17U20' },
  { label: 'IsJuniorGoldU15U18', key: 'isJuniorGoldU15U18' },
  { label: 'IsJuniorGoldU20', key: 'isJuniorGoldU20' },
  { label: 'IsJuniorGoldActive', key: 'isJuniorGoldActive' },
	{ label: 'AddressLine1', key: 'addressLine1' },
	{ label: 'AddressLine2', key: 'addressLine2' },
	{ label: 'City', key: 'city' },
	{ label: 'State', key: 'state' },
	{ label: 'Zip', key: 'zip' },
	{ label: 'Country', key: 'country' },
	{ label: 'PhoneNumber', key: 'phoneNumber' },
  { label: 'EmailAddress', key: 'emailAddress' },
  { label: 'ParentGuardianEmail', key: 'parentGuardianEmail' },
	{ label: 'DateAdded', key: 'dateAdded' },
	{ label: 'Status', key: 'status' },
	{ label: 'Standing', key: 'standing' },
	{ label: 'Promoted', key: 'promoted' },
	{ label: 'PromotionDate', key: 'promotionDate' },
	{ label: 'Division', key: 'division' },
	{ label: 'Event', key: 'event' },
	{ label: 'DirectorName', key: 'directorName' },
	{ label: 'StartDate', key: 'startDate' },
	{ label: 'EndDate', key: 'endDate' },
	{ label: 'OptOutDate', key: 'optOutDate' },
	{ label: 'AuthorizedBy', key: 'authorizedBy' },
	{ label: 'Reason', key: 'reason' }
 ]


// WEBPACK FOOTER //
// ./src/containers/reports/constants/athletesHeaders.js